import React from "react";
import "./Header.scss";
import { GiHamburgerMenu } from "react-icons/gi";
import images from "../../images";
import { Link } from "react-router-dom";

export default function Header({ showNav, navHidden }) {
  return (
    <div className="Header">
      <Link to="/" className="logo">
        <img alt="logo" src={images.logo}></img>
      </Link>
      {!navHidden && (
        <div className="menuButton" onClick={() => showNav()}>
          <GiHamburgerMenu></GiHamburgerMenu>
        </div>
      )}
    </div>
  );
}
